<template>
  <cv-header-menu aria-label="Ditte" title="Ditte" v-bind:hover-toggle="autoapertura">
    <cv-header-menu-item href="/#/clienti">Clienti</cv-header-menu-item>
    <cv-header-menu-item href="/#/fornitori">Fornitori</cv-header-menu-item>
    <cv-header-menu-item href="/#/terzisti">Terzisti</cv-header-menu-item>
  </cv-header-menu>
</template>

<script>
export default {
  name: "MenuDitte",
  props: {
    autoapertura: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
</style>